import { Box, Flex } from 'reflexbox';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Paragraph, Subheading } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';
import useViewerRoles from 'packages/kakapo-ui-application/hooks/useUserRoles';
import ConversationParty from 'conversations/ConversationParty';

export default function EvaluationSubmissionUnsign(props: {
	submission: graphql.EvaluationSubmission;
}) {
	const roles = useViewerRoles();
	const { t } = useTranslation();
	const [loadingType, setLoadingType] = useState<'employee' | 'manager'>('employee');

	const [unsign, { loading }] = graphql.useUnsignEvaluationSubmissionMutation();

	if (
		!roles.isWorkspaceSuperuser ||
		(props.submission.employee.status !== graphql.EvaluationSubmissionStatus.Signed &&
			props.submission.manager.status !== graphql.EvaluationSubmissionStatus.Signed)
	) {
		return null;
	}

	return (
		<Box mb={4} width={6 / 12}>
			<Subheading>{t('evaluation.submission.undo.title')}</Subheading>
			<Paragraph>{t('evaluation.submission.undo.description')}</Paragraph>
			{props.submission.employee.status === graphql.EvaluationSubmissionStatus.Signed && (
				<Flex mt={3} justifyContent="space-between" alignItems="center" flexDirection="row">
					<Box flexGrow={1} flexShrink={1}>
						<ConversationParty
							result={props.submission.employee as graphql.EvaluationSubmissionResult}
						/>
					</Box>
					<Box flexGrow={0} flexShrink={0}>
						<Button
							onClick={() => {
								setLoadingType('employee');
								unsign({
									variables: {
										input: {
											id: props.submission.id,
											party: graphql.EvaluationSubmissionParty.Employee,
										},
									},
								});
							}}
							title={t('evaluation.submission.undo.employee.button.title')}
							small
							loading={loading && loadingType === 'employee'}
						/>
					</Box>
				</Flex>
			)}
			{props.submission.manager.status === graphql.EvaluationSubmissionStatus.Signed && (
				<Flex mt={3} justifyContent="space-between" alignItems="center" flexDirection="row">
					<Box flexGrow={1} flexShrink={1}>
						<ConversationParty
							width={300}
							result={props.submission.manager as graphql.EvaluationSubmissionResult}
						/>
					</Box>
					<Box flexGrow={0} flexShrink={0}>
						<Button
							onClick={() => {
								setLoadingType('manager');
								unsign({
									variables: {
										input: {
											id: props.submission.id,
											party: graphql.EvaluationSubmissionParty.Manager,
										},
									},
								});
							}}
							title={t('evaluation.submission.undo.manager.button.title')}
							small
							loading={loading && loadingType === 'manager'}
						/>
					</Box>
				</Flex>
			)}
		</Box>
	);
}
